export const VIEWED_PRODUCTS_KEY: string = 'viewed_products_key' as const;
